import moment from 'moment';
import { reportBKPageError, reportBKTimeCost } from '../../../api/';
import { getConfig } from '../../../config';
import {
  BKErrorLevel,
  BKEventName,
  IBKReportType,
} from '../../../model/api-modules/bk-report';
import { store } from '../../../store';
import { getLoginToken } from '../login';

export const reportPageError = (error: any, apiPath = '') => {
  try {
    if (!checkReport(apiPath)) {
      return;
    }
    const { selectStudio } = store.getState().studio;
    const selectedGame = store.getState().games.selectGame;
    const selectedEnv = store.getState().games.selectEnv;
    reportBKPageError({
      type: IBKReportType.Event,
      data: [
        {
          event_name: BKEventName.PortalWebException,
          event: {
            content: `InGame DevPortal页面异常告警：deployArea: ${
              getConfig().deployArea
            }, studio_id: ${selectStudio?.studioID || '0'}, game_id: ${
              selectedGame?.gameID || '0'
            }, env_id:${selectedEnv?.Guid || '0'}, apiPath: ${getApiPath(
              apiPath
            )}, ${error}`,
          },
          dimension: {
            path: location.pathname,
            userID: store.getState().common.userInfo?.UserID || '',
            location: getConfig().deployArea,
            module: 'web',
            level: BKErrorLevel.Fatal,
          },
          target: '127.0.0.1',
          timestamp: moment().valueOf(),
        },
      ],
    });
  } catch (err) {}
};

export const wrapTimeReport = async (fun: Function) => {
  try {
    const beginTime = moment().valueOf();
    const res = await fun();
    reportBKTimeCost({
      type: IBKReportType.Metric,
      data: [
        {
          metrics: {
            dev_portal_page_time_cost: moment().diff(moment(beginTime)),
          },
          dimension: {
            path: location.pathname,
            userID: store.getState().common.userInfo?.UserID || '',
            location: getConfig().deployArea,
            module: 'web',
          },
          target: '127.0.0.1',
          timestamp: moment().valueOf(),
        },
      ],
    });

    return res;
  } catch (err) {}
};

function checkReport(apiPath = '') {
  const ticket = getLoginToken();
  if (!ticket || apiPath.includes('/api/bk/report')) {
    return false;
  }
  return true;
}

function getApiPath(path = '') {
  if (path.startsWith('http')) {
    const urlObject = new URL(path);
    if (location.origin === urlObject.origin) {
      return urlObject.pathname + urlObject.search;
    }
  }
  return path;
}

// 监听同步错误
window.addEventListener('error', (event) => {
  console.error('全局同步错误:', event.error);
  reportPageError(event.error);
});

// 监听未处理的 Promise 拒绝
window.addEventListener('unhandledrejection', (event) => {
  console.error('未处理的 Promise 错误:', event.reason);
  reportPageError(event.reason);
});
